// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'element-ui/lib/theme-chalk/index.css'
import Element, { Loading } from 'element-ui'

import VueCookie from 'vue-cookie'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'
import 'wowjs/css/libs/animate.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import UAParser from 'ua-parser-js'
// 定义全局
import Validator from '@/utils/validator'
import sysconstant from '@/utils/sysconstant'
// 定义全局
import util from '@/utils/util'
import '@/assets/css/common.css'
import httpToHttps from '@/filter/httpToHttps'
import moment from 'moment'
import scrollbar from '@/directive/scrollbar'

// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入折线图
require('echarts/lib/chart/line')
require('echarts/lib/chart/lines')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
Vue.use(preview)
// import Swiper from 'swiper';
// import 'swiper/dist/css/swiper.min.css';
Vue.config.productionTip = false
Vue.use(Loading)
Vue.use(Element)
Vue.use(VueCookie)
Vue.use(httpToHttps)
Vue.use(scrollbar)

Vue.prototype.SysConstant = sysconstant
Vue.prototype.$rules = Validator
Vue.prototype.$echarts = echarts
Vue.prototype.$util = util
Vue.prototype.$message = Element.Message
Vue.prototype.$confirm = Element.MessageBox.confirm
Vue.prototype.$alert = Element.MessageBox.alert
Vue.prototype.$moment = moment
// 判断以什么开头
if (typeof String.prototype.startsWith !== 'function') {
  String.prototype.startsWith = function (prefix) {
    return this.slice(0, prefix.length) === prefix
  }
}
// 判断是否是前台展示页面
function isfront (to, next) {
  if (to.fullPath == '/' || to.fullPath.startsWith('/front')) {
    return true
  } else {
    return false
  }
}

let device = null
router.beforeEach((to, from, next) => {
  device = new UAParser().getDevice()
  let webpageVisibleW = document.documentElement.clientWidth || document.body.clientWidth

  // 记录上一次记录的地址。
  window.scrollTo(0, 0)
  // 页面未找到直接跳转到404
  if (to.matched.length === 0) {
    next({ name: 'e404' })
  }
  if (['htmlSplit', 'preview', 'previewV2'].includes(to.name)) {
    return next()
  }

  if (to.path == '/admin/login' || isfront(to, next)) {
    if ((device.type === 'mobile' && webpageVisibleW < 1200) || (device.type === 'tablet' && webpageVisibleW < 1200)) {
      if (to.path.indexOf('/front/Mobilehome') !== -1) {
        next()
      } else {
        next({name: 'Mobilehome'})
      }
    } else {
      if (to.path.indexOf('/') !== -1) {
        next()
      } else {
        next({name: 'Mobilehome'})
      }
    }
  } else if (util.isEmptyObject(store.state.user.userinfo)) {
    store.dispatch('fetchUserInfo')
    next()
  } else next()
})
window.onload = function () {
  setTimeout(function () {
    if (document.body.scrollTop > 0) {
      window.scrollTo(0, -1)
      document.body.scrollTop = 0
    }
    window.scrollTo(0, -1)
    document.body.scrollTop = 0
  }, 10)
}
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  return fmt
}

// 引入统一的管理
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js